/**
 * Describes a data-row variable option for a selectable figure type.
 */
export interface FigureTypeOptionDataRowVar {
  varName: string;
  label: string;
  type: "number" | "string" | "select";
  options?: string[];
}

/**
 * Describes a selectable figure type option and its supported data-row variables.
 */
export interface FigureTypeOptionsProps {
  value: string;
  label: string;
  dataRowVars: FigureTypeOptionDataRowVar[];
}
